import { FLOLDER, FOLDER_TREE_MAX_COUNT, FOLDER_TREE_MAX_DEEP } from '../../common/constant';
import Message from '@web-common/components/UI/Message/SiriusMessage';
import { treeDFS, getTreeNodeById, folderIdIsContact, createAllFolderId } from '../../util';
import { getIn18Text } from 'api';
import { apiHolder } from 'api';
const systemApi = apiHolder.api.getSystemApi();
export const folderCanSortByTop = (fid, isCorpMail = false) => !isCorpMail
    ? fid && !folderIdIsContact(fid) && fid != FLOLDER.DELETED && fid != FLOLDER.SPAM && fid > 0
    : fid && fid !== FLOLDER.SPAM && fid !== FLOLDER.TASK && fid !== FLOLDER.UNREAD;
export const orderCanSortByTop = (mailListStateTab) => {
    return mailListStateTab === 'ALL' || !mailListStateTab.startsWith('ORDER_BY_');
};
export const validateFolderHasRepeatName = (nodeList) => {
    let isRepeat = false;
    try {
        if (nodeList && nodeList.length) {
            const nameList = nodeList.map(item => item.entry.mailBoxName.toLowerCase().trim());
            isRepeat = nameList.length !== [...new Set(nameList)].length && nodeList.length > 0;
        }
    }
    catch (_a) {
        return isRepeat;
    }
    return isRepeat;
};
export const checkRepeatFromFolderList = (nodeList, node) => {
    try {
        if (nodeList && nodeList.length) {
            return nodeList.some(item => {
                var _a, _b;
                const name = (_a = item === null || item === void 0 ? void 0 : item.entry) === null || _a === void 0 ? void 0 : _a.mailBoxName;
                const aimName = (_b = node === null || node === void 0 ? void 0 : node.entry) === null || _b === void 0 ? void 0 : _b.mailBoxName;
                if (name != null && aimName != null) {
                    return name.toLowerCase().trim() === aimName.toLowerCase().trim();
                }
                return false;
            });
        }
    }
    catch (_a) {
        return false;
    }
    return false;
};
export const validateFolderNameIsRepeat = (nodeList, node) => {
    let isRepeat = false;
    try {
        if (nodeList && nodeList.length) {
            isRepeat = nodeList.find(item => item.entry.mailBoxName.toLowerCase().trim() === node.entry.mailBoxName.toLowerCase().trim()) != null;
        }
    }
    catch (_a) {
        return isRepeat;
    }
    return isRepeat;
};
export const validateFolderCountOverMax = (tree) => {
    let sum = 0;
    treeDFS(tree, () => {
        sum += 1;
    });
    return sum > FOLDER_TREE_MAX_COUNT;
};
export const validateFolderDeepOverMax = (node) => node && node.entry._deep != null && node.entry._deep > FOLDER_TREE_MAX_DEEP;
export const validateFolderOperIncludeNode = (tree) => {
    let isOverMaxDeep = false;
    treeDFS(tree, (node) => {
        if (!isOverMaxDeep && validateFolderDeepOverMax(node)) {
            isOverMaxDeep = true;
        }
    });
    if (isOverMaxDeep) {
        Message.warn({
            content: `移动失败,最多可新建${FOLDER_TREE_MAX_DEEP}级子文件夹`,
        });
        return false;
    }
    if (validateFolderCountOverMax(tree)) {
        Message.warn({
            content: getIn18Text('YIDONGSHIBAI\uFF0C13'),
        });
        return false;
    }
    let isRepeatName = false;
    treeDFS(tree, (node) => {
        const childList = node.children || [];
        if (childList && childList.length && !isRepeatName) {
            if (validateFolderHasRepeatName(childList)) {
                isRepeatName = true;
            }
        }
    });
    if (!isRepeatName && Array.isArray(tree)) {
        if (validateFolderHasRepeatName(tree)) {
            isRepeatName = true;
        }
    }
    if (isRepeatName) {
        Message.warn({
            content: getIn18Text('YIDONGSHIBAI\uFF0C14'),
        });
        return false;
    }
    return true;
};
export const validateFolderListIncludeName = (tree, name) => !!tree.find(node => node.entry.mailBoxName.trim().toLowerCase() === name.trim().toLowerCase());
export const validateFolderOperForNode = (tree, curNode, dragNode, dropToGap, dropPosition) => {
    var _a, _b, _c, _d, _e;
    if (!tree || !curNode || !dragNode) {
        return false;
    }
    const nodePid = ((_a = curNode === null || curNode === void 0 ? void 0 : curNode.entry) === null || _a === void 0 ? void 0 : _a.pid) || 0;
    const nodeId = (_b = curNode === null || curNode === void 0 ? void 0 : curNode.entry) === null || _b === void 0 ? void 0 : _b.mailBoxId;
    const dragNodePid = ((_c = dragNode === null || dragNode === void 0 ? void 0 : dragNode.entry) === null || _c === void 0 ? void 0 : _c.pid) || 0;
    const dragId = (_d = dragNode === null || dragNode === void 0 ? void 0 : dragNode.entry) === null || _d === void 0 ? void 0 : _d.mailBoxId;
    const dragName = (_e = dragNode === null || dragNode === void 0 ? void 0 : dragNode.entry) === null || _e === void 0 ? void 0 : _e.mailBoxName;
    const isCross = nodePid !== dragNodePid;
    let systemFolderList = getSystemTopFolder(tree);
    let isRepeatName = false;
    let isOverDeep = false;
    let systemFolderPosiError = false;
    let systemFolderInsertError = false;
    if (dropToGap) {
        if (nodePid === 0) {
            if (isCross && checkRepeatFromFolderList(systemFolderList, dragNode)) {
                isRepeatName = true;
            }
        }
        else {
            const parentNode = getTreeNodeById(tree, nodePid);
            if (isCross && validateFolderListIncludeName(parentNode === null || parentNode === void 0 ? void 0 : parentNode.children, dragName)) {
                isRepeatName = true;
            }
        }
    }
    else {
        if (nodeId === 0) {
            if (checkRepeatFromFolderList(systemFolderList, dragNode)) {
                isRepeatName = true;
            }
        }
        else {
            if (dragId < 100) {
                systemFolderPosiError = true;
            }
            if (nodeId < 0) {
                systemFolderInsertError = true;
            }
            if (nodeId != dragNodePid && validateFolderListIncludeName(curNode === null || curNode === void 0 ? void 0 : curNode.children, dragName)) {
                isRepeatName = true;
            }
            if (curNode.entry._deep - 1 >= FOLDER_TREE_MAX_DEEP) {
                isOverDeep = true;
            }
        }
    }
    if (systemFolderPosiError) {
        Message.error({
            content: getIn18Text('XITONGWENJIANJIA'),
        });
        return false;
    }
    if (systemFolderInsertError) {
        Message.error({
            content: getIn18Text('BUNENGCHARUDAO'),
        });
        return false;
    }
    if (isRepeatName) {
        Message.error({
            content: getIn18Text('YIDONGSHIBAI\uFF0C14'),
        });
        return false;
    }
    if (isOverDeep) {
        Message.error({
            content: `移动失败,最多可新建${FOLDER_TREE_MAX_DEEP}级子文件夹`,
        });
        return false;
    }
    return true;
};
export const getSystemTopFolder = (tree) => {
    const systemFolderList = [];
    tree.forEach(node => {
        var _a;
        const pid = ((_a = node === null || node === void 0 ? void 0 : node.entry) === null || _a === void 0 ? void 0 : _a.pid) || 0;
        if (pid == 0) {
            systemFolderList.push(node);
        }
    });
    return systemFolderList;
};
export const validateFolderHasRepeatNamePrue = (nodeList, aimNode) => {
    let isRepeat = false;
    try {
        if (nodeList && nodeList.length) {
            const nameList = nodeList.map(item => item.entry.mailBoxName.toLowerCase().trim());
            isRepeat = nameList.includes(aimNode.entry.mailBoxName);
        }
    }
    catch (_a) {
        return isRepeat;
    }
    return isRepeat;
};
export const filterNotMainFolder = (list) => {
    if (list && Array.isArray(list)) {
        return list.filter((item) => item.entry.mailBoxId != FLOLDER.TASK &&
            item.entry.mailBoxId != FLOLDER.WAITINGISSUE &&
            item.entry.mailBoxId != FLOLDER.READYISSUE &&
            item.entry.mailBoxId != FLOLDER.DEFER &&
            item.entry.mailBoxId != FLOLDER.STAR);
    }
    return list;
};
const allFolderFidMap = {
    '-41': { name: getIn18Text('SHOUJIANXIANG'), fid: FLOLDER.DEFAULT, show: true },
    '-42': { name: getIn18Text('WEIDUYOUJIAN'), fid: FLOLDER.UNREAD, show: true },
    '-43': { name: getIn18Text('FAJIANXIANG'), fid: FLOLDER.SENT, show: true },
    '-47': { name: getIn18Text('YOUDANGDAIGJ'), fid: FLOLDER.CUSTOMER_UNFOLLOW, show: true },
    '-48': { name: getIn18Text('WUDANGDAIGJ'), fid: FLOLDER.UNFOLLOW, show: true },
    '-44': { name: getIn18Text('HONGQIYOUJIAN'), fid: FLOLDER.REDFLAG, show: true },
    '-45': { name: getIn18Text('CAOGAOXIANG'), fid: FLOLDER.DRAFT, show: true },
    '-49': { name: getIn18Text('YINGXIAOQIANKHF'), fid: FLOLDER.EDM_REPLY, show: true },
    '-50': { name: getIn18Text('YINGXIAOQITHF'), fid: FLOLDER.EDM_OTHER_REPLY, show: true },
};
export const mergeAllFolderList = (data, otherClusterNode, accountIds) => {
    var _a;
    const mainAccount = systemApi.getMainAccount().email;
    let accounts = Object.keys(data);
    if (accountIds && accountIds.length) {
        accounts.push(...accountIds);
        accounts = [...new Set(accounts)];
    }
    const allMailBoxModel = [];
    const allFolderFidMapKey = process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion) ? ['-41', '-42', '-43', '-47', '-48', '-44', '-45'] : ['-41', '-42', '-43', '-44', '-45'];
    const HAS_EDM_REPLY = Object.values(data)
        .flat()
        .some(f => f.mailBoxId === FLOLDER.EDM_REPLY);
    const HAS_EDM_OTHER_REPLY = Object.values(data)
        .flat()
        .some(f => f.mailBoxId === FLOLDER.EDM_OTHER_REPLY);
    if (HAS_EDM_REPLY) {
        allFolderFidMapKey.push('-49');
    }
    if (HAS_EDM_OTHER_REPLY) {
        allFolderFidMapKey.push('-50');
    }
    allFolderFidMapKey.forEach(allMailBoxId => {
        const children = [];
        let mailBoxCurrentUnread = 0;
        let mailBoxUnread = 0;
        let mailBoxTotal = 0;
        let threadMailBoxCurrentUnread = 0;
        let threadMailBoxUnread = 0;
        let threadMailBoxTotal = 0;
        accounts.forEach(account => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const allFolders = data[account];
            if (!allFolders) {
                children.push({
                    mailBoxId: createAllFolderId(allMailBoxId, account),
                    _account: account,
                    entry: {
                        mailBoxName: ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.agentEmail) || account,
                        mailBoxCurrentUnread: 0,
                        mailBoxUnread: 0,
                        mailBoxTotal: 0,
                        mailBoxType: 'sys',
                        mailBoxId: createAllFolderId(allMailBoxId, account),
                        threadMailBoxCurrentUnread: 0,
                        threadMailBoxUnread: 0,
                        threadMailBoxTotal: 0,
                        mailBoxParent: 0,
                        id: createAllFolderId(allMailBoxId, account),
                        pid: allMailBoxId,
                        sort: 0,
                        _state: 'DEFAULT',
                        _deep: 1,
                        _isTempNode: false,
                        expire: true,
                    },
                    children: [],
                });
            }
            else {
                const child = allFolders.find((fold) => fold.entry.mailBoxId === allFolderFidMap[allMailBoxId].fid || fold.mailBoxId === allFolderFidMap[allMailBoxId].fid);
                if (child) {
                    if (!(otherClusterNode &&
                        account &&
                        otherClusterNode.some(item => {
                            var _a;
                            return item.id == ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id);
                        }))) {
                        mailBoxCurrentUnread += ((_b = child.entry) === null || _b === void 0 ? void 0 : _b.mailBoxCurrentUnread) || 0;
                        mailBoxUnread += ((_c = child.entry) === null || _c === void 0 ? void 0 : _c.mailBoxCurrentUnread) || 0;
                        mailBoxTotal += ((_d = child.entry) === null || _d === void 0 ? void 0 : _d.mailBoxTotal) || 0;
                        threadMailBoxCurrentUnread += ((_e = child.entry) === null || _e === void 0 ? void 0 : _e.threadMailBoxCurrentUnread) || 0;
                        threadMailBoxUnread += ((_f = child.entry) === null || _f === void 0 ? void 0 : _f.threadMailBoxUnread) || 0;
                        threadMailBoxTotal += ((_g = child.entry) === null || _g === void 0 ? void 0 : _g.threadMailBoxTotal) || 0;
                    }
                    else {
                        child.entry.expire = true;
                    }
                    child.entry.mailBoxName = ((_h = systemApi.getCurrentUser(account)) === null || _h === void 0 ? void 0 : _h.agentEmail) || account;
                    child.mailBoxId = createAllFolderId(allMailBoxId, account);
                    child.entry.mailBoxId = createAllFolderId(allMailBoxId, account);
                    child.entry.id = createAllFolderId(allMailBoxId, account);
                    child.entry.mailBoxUnread = child.entry.mailBoxCurrentUnread;
                    child.entry.pid = +allMailBoxId;
                    child.children = [];
                    child.childrenCount = 0;
                    children.push(child);
                }
            }
        });
        allMailBoxModel.push({
            childrenCount: children.length || 0,
            _account: mainAccount,
            authAccountType: '0',
            entry: {
                mailBoxName: allFolderFidMap[allMailBoxId].name,
                mailBoxCurrentUnread,
                mailBoxUnread,
                mailBoxTotal,
                mailBoxType: 'sys',
                mailBoxId: allMailBoxId,
                threadMailBoxCurrentUnread,
                threadMailBoxUnread,
                threadMailBoxTotal,
                mailBoxParent: 0,
                id: allMailBoxId,
                pid: 0,
                sort: 0,
                _state: 'DEFAULT',
                _deep: 1,
                _isTempNode: false,
            },
            children,
            mailBoxId: allMailBoxId,
        });
    });
    return allMailBoxModel;
};
